module.exports = __webpack_public_path__ + "static/bg9.381558e8.png";